export default "__VITE_ASSET___bSLaS5p__"